export default function StatusBadge({ status }: { status: string }) {
  const color =
    status === "approved"
      ? "green"
      : status === "rejected"
      ? "red"
      : "orange";

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: 6,
        fontSize: 12,
        fontWeight: 600,
        background: color,
        color: "white",
      }}
    >
      {status.toUpperCase()}
    </span>
  );
}
